import {arrowIncreaseSvg as Icon__small__arrowIncreaseSvg} from '../Icon__small/Icon__small--arrowIncrease.js';

export var arrowIncrease = {
  name: 'arrowIncrease',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowIncreaseSvg,
};
